import { Link } from 'react-router-dom';

import { OAuthButton } from '@/components/common/auth/OAuthButton';
import { Logo } from '@/components/common/Logo';
import { SignUpForm } from '@/components/forms/auth/SignUpForm';
import { OAUTH_PROVIDER_ORDER } from '@/constants/auth-providers';
import { orgPath } from '@/helpers/org-path.helper';
import { useOAuthSignIn } from '@/hooks/auth/useOAuthSignIn';

export const SignUp = ({
  isInternalHostname,
}: {
  isInternalHostname: boolean;
}) => {
  // custom hooks
  const { pendingProvider, authenticateWith } = useOAuthSignIn({
    continueSignUp: true,
    // Without an active organization there is no org page to land on.
    redirectUrlComplete: window.localStorage.getItem('active-org-id')
      ? `${window.location.origin}${orgPath('/auth/join-org')}`
      : '/',
  });

  return (
    <div className="mx-auto flex min-h-full w-full max-w-[400px] flex-col justify-center px-4 max-sm:items-center lg:w-1/2">
      <div className="flex">{isInternalHostname && <Logo />}</div>
      <h2 className="as-strong mb-6 mt-10 text-black">Create your account</h2>
      <SignUpForm />
      <div className="my-4 flex items-center">
        <div className="h-[1px] w-full bg-neutral-200" />
        <p className="as-title-03 as-strong px-2 text-neutral-500">OR</p>
        <div className="h-[1px] w-full bg-neutral-200" />
      </div>
      <div className="space-y-3">
        {OAUTH_PROVIDER_ORDER.map((provider) => (
          <OAuthButton
            key={provider}
            provider={provider}
            loading={pendingProvider === provider}
            disabled={Boolean(pendingProvider) && pendingProvider !== provider}
            onClick={authenticateWith}
          />
        ))}
      </div>

      <p className="as-title-03 mt-4 text-center text-muted-foreground">
        Already have an account?
        <Link
          to={orgPath('/auth/sign-in')}
          className="as-strong ml-2 text-brand-700"
        >
          Sign in
        </Link>
      </p>
    </div>
  );
};
